import { BASE_URL } from '../config';

export interface LevelPuzzle {
  id: string;
  num: number;
  imageUrl: string;
  difficulty: number; // Grid size
  seed: number; // Seeded RNG seed (0 = use Math.random)
}

const LEVELS_PER_PAGE = 20;

// Cache fetched puzzles by level number
const puzzleCache = new Map<number, LevelPuzzle>();

export { LEVELS_PER_PAGE };

export async function getLevelPuzzleByNum(num: number): Promise<LevelPuzzle | undefined> {
  if (puzzleCache.has(num)) {
    return puzzleCache.get(num);
  }

  try {
    const response = await fetch(`${BASE_URL}/Rest/level/${num}`);

    if (!response.ok) {
      if (response.status === 404) {
        console.log('No level puzzle available for level:', num);
        return undefined;
      }
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    const puzzle: LevelPuzzle = data.result || data;

    if (!puzzle.imageUrl) {
      console.warn('API returned level puzzle without imageUrl');
      return undefined;
    }

    puzzle.num = num;
    puzzleCache.set(num, puzzle);
    return puzzle;
  } catch (error) {
    console.error('Error fetching level puzzle:', error);
    return undefined;
  }
}
